/**
 * PublicLayout
 *
 * Wrapper for public-facing pages that includes the tracking pixel.
 * Used for pages that don't require authentication.
 */
import { ReactNode } from 'react';
import { PublicTrackingPixel } from './PublicTrackingPixel';

interface PublicLayoutProps {
  children: ReactNode;
}

export function PublicLayout({ children }: PublicLayoutProps) {
  return (
    <div className="public-theme-scope min-h-screen bg-surface-cream text-ink-deep-navy">
      <PublicTrackingPixel />
      {children}
    </div>
  );
}
